import { Navigate, Outlet } from 'react-router-dom';
import { getAuthAndUser } from 'utils/auth-user-storage';

const AccessControl = ({
  routePath,
  routePermission,
  isAuthenticatedRoute,
}) => {
  if (
    !isAuthenticatedRoute ||
    (isAuthenticatedRoute && getAuthAndUser().authToken)
  ) {
    if (
      routePermission.length > 0 &&
      !routePermission.includes(getAuthAndUser()?.user?.role)
    ) {
      return <Navigate to="/unauthorized" replace />;
    }

    if (
      [
        '/login',
        '/forget-password',
        '/otp-verification',
        '/email-confirmation',
        '/reset-password',
      ].includes(routePath) &&
      getAuthAndUser().authToken
    ) {
      return <Navigate to="/dashboard" replace />;
    }
    return <Outlet />;
  } else {
    return <Navigate to="/login" replace />;
  }
};

export default AccessControl;
